import { render, staticRenderFns } from "./destinationDetail.vue?vue&type=template&id=7d56f738&scoped=true&"
import script from "./destinationDetail.vue?vue&type=script&lang=js&"
export * from "./destinationDetail.vue?vue&type=script&lang=js&"
import style0 from "./destinationDetail.vue?vue&type=style&index=0&id=7d56f738&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d56f738",
  null
  
)

export default component.exports